// src/components/admin/AdminLogin.jsx
import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom'; // Added useLocation
import { toast } from 'react-toastify';
import './AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Added to get the intended destination

  // Get the page user was trying to access (if any)
  const from = location.state?.from || '/admin/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/login.php', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password })
      });
      
      const text = await response.text();
      console.log('Raw response:', text);
      
      // Clean the response by removing any non-JSON text
      let cleanText = text;
      const jsonStart = text.indexOf('{');
      if (jsonStart > 0) {
        cleanText = text.substring(jsonStart);
      }
      
      let data;
      try {
        data = JSON.parse(cleanText);
      } catch (e) {
        console.error('Failed to parse JSON:', cleanText);
        toast.error('Server returned invalid response');
        setLoading(false);
        return;
      }
      
      if (data.success) {
        localStorage.setItem('adminToken', 'logged_in');
        localStorage.setItem('adminData', JSON.stringify(data.admin));
        toast.success('Login successful!');
        
        // Redirect to the page they were trying to access, or dashboard
        navigate(from, { replace: true });
      } else {
        toast.error(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="login-header">
          <h2>Admin Login</h2>
          <p>WebCraft Admin Panel</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@demo-site.com"
            />
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••"
            />
          </div>
          
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? 'Logging in...' : 'Login'}
          </button>
          
          <div className="forgot-password-link">
            <Link to="/admin/forgot-password">Forgot Password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;